const ProductPage = () => (
  <div className="p-8 text-center">
    <h2 className="text-3xl font-bold mb-4">Our Product</h2>
    <p className="text-gray-600">Learn more about the features we provide.</p>
  </div>
);

export default ProductPage;